export enum TransactionRuleFieldsEnum {
  NotSet = 0,
  Merchant = 1,
  Description = 2
}
